import React, { Component } from 'react';
import { Format } from '../../helpers/formatDate';
import * as  eChartCommon from '../echart/eChartCommon';
export function getRandom() {
  return Math.floor(Math.random() * 10000000000);
  // Format(new Date(), 'yyyy-MM-dd hh:mm:ss');
}
export const isDebug = false;
export const sourceEvents = {
  "click": "click",
  "doubleClick": "doubleClick"
}
export const destEvents = {
  "drop": "drop",
  "url": "url"
}
export function LogChartInfo(logStr, errNumber) {
  eChartCommon.LogChartInfo(logStr, "", errNumber)
}

export function getDataSourceFieldValue(obj, type) {
  // type 1:caption   2: state className

  if (typeof (obj) == "object") {
    if (type == 1) {
      return obj.text;
    }
    else if (type == 2) {
      return obj.icon || obj.value;
    }
    else {
      LogChartInfo("热区获取FieldValue出错。 obj = " + JSON.stringify(obj) + " type = " + type, 901)
    }
  }
  else if (typeof (obj) == "string" || typeof (obj) == "number") {
    return obj;
  }
  else {
    LogChartInfo("热区获取FieldValue出错。 obj = " + JSON.stringify(obj) + " type = " + type, 901)
    return obj || "";
  }
}
export function JSONParse(config) {
  let obj = config;
  if (typeof (config) == "string")
    if (config.trim() != "")
      obj = JSON.parse(config);
  return obj;
}
export function getDebugCStyle(bDesign) {
  // return { "codeField": "code", "stateField": "stop", "captionFields": "code,name" };
  // return { extendClassName: "扩展类名", refreshInterval: 5000, "codeField": "code", "stateField": "stop", "mapConfigField": "", "captionFields": [{ "field": "code", "prefix": "", "suffix": "" }, { "field": "name", "prefix": "", "suffix": "" }] };
  let obj = {
    "extendClassName": "扩展类名_",
    "refreshInterval": -1,
    "codeField": "",
    "nameField": "",
    "stateField": "",
    "mapConfigField": "",
    "fieldsCaption": "",
    "captionFields": [
      { "field": "areaClass_name", "prefix": "", "suffix": "" },
      { "field": "name", "prefix": "", "suffix": "" }
    ],
    "refResetFields": ["room_roomType"],
    "triggerEvents": {}//"click": "drop", "doubleClick": "url"
  };
  // obj.triggerEvents[sourceEvents.click] = destEvents.drop;
  // obj.triggerEvents[sourceEvents.doubleClick] = destEvents.url;
  obj.triggerEvents[sourceEvents.click] = destEvents.drop;

  if (bDesign) {
    obj.codeField = "areaClass_name";
    obj.nameField = "name";
    obj.stateField = "stop";
    obj.fieldsCaption = "热区信息";

    obj.codeField = "room_code";
    obj.nameField = "room_name";
    obj.stateField = "stop";
    obj.fieldsCaption = "热区信息";
  }
  else {
    obj.codeField = "code";
    obj.nameField = "name";
    obj.stateField = "stop";
    obj.refreshInterval = 5000;
  }
  return obj;
}
export function getNullMapConfig() {
  // return {
  //   id: -1,
  //   imgUrl: "http://resourceyxy.yonyouup.com/5d711f7d-dc14-4f78-ac4e-40fea5fe4f0d.png",
  //   height: 617,
  //   width: 821,
  //   coordinates: [
  //     { x: 15, y: 250, width: 50, height: 50, id: "sM54yalu7", code: "F01", name: "小包",   url: "" },
  //     { x: 100, y: 250, width: 80, height: 80, id: "sM54yalu8", code: "F02", name: "大包",   url: "" }
  //   ]
  // };
  return {
    id: -1,
    imgUrl: "",
    height: 400,
    width: 600,
    coordinates: []
  };
}

export function getDebugMapConfig() {
  return {
    "id": 123,
    "imgUrl": "http://resourceyxy.yonyouup.com/5d711f7d-dc14-4f78-ac4e-40fea5fe4f0d.png",
    "height": 617,
    "width": 821,
    "coordinates": [{
      "x": 1,
      "y": 182,
      "width": 83,
      "height": 37,
      "id": "E216I8bsD",
      "code": "0101",
      "url": "http://www.baidu.com"
    }, {
      "x": 86,
      "y": 183,
      "width": 61,
      "height": 36,
      "id": "CIpkQvxwW",
      "code": "0003",
      "url": "http://www.JD.com"
    }]
  };
}



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/meta/HotAreaMapCommon.jsx